import React from 'react'

const SubtringLote = (props) => {
    const fecha = JSON.stringify(props.idlote) || ''
    const lote = fecha.substring(37, 32, 5)


    if (fecha === '' || fecha === 'undefined') {
        return (
            <>
            </>
        )
    }
    else {
        return (
            <>
                {lote}
            </>)

    }
}

export default SubtringLote